import config from '../config';

const URLs = {
  apisV1: '/v1',
  apisV2: '/v2',
  CREATE_PRODUCT: '/custom-builder/product',
  favorite: '/v1/favorites',
  syncFavorites: '/v1/favorites/sync',
  BASE_PRODUCT_URL:
    '/rings/profiles/D/widths/7/ring_materials/14KW?ring_finish=SATIN&finish_type=F&weight=P&size=10&feature_group=N&sleeve=NONE',
  ...config,
  // Must come after the spread. config falls back to the LASHBROOK behavior defaults, whose
  // assetsBaseUrl is hardcoded to staging, so spreading it last pointed production builds at
  // the staging asset renderer while the API stayed on production — the renderer 500s on
  // product configs it doesn't have. The build's own env var is authoritative.
  assetsBaseUrl: process.env.REACT_APP_ASSET_URL || config.assetsBaseUrl
};
export default URLs;
